import { useCallback, useState } from 'react';
import { useManualGql } from '@search/gql-client/src';
import { ExecutionError } from '@search/gql-client/src';
import { QueryErrors } from '../types/QueryErrors';
import { AgentEditFavoriteMutation } from './AgentEditFavoriteMutation';
import { AgentEditFavoriteMutation$variables, AgentEditFavoriteMutation$data } from './__generated__/AgentEditFavoriteMutation.graphql';

export interface IUseEditFavoriteReturnType {
    onEditFavorite: (args: AgentEditFavoriteMutation$variables) => Promise<AgentEditFavoriteMutation$data>;
    editFavoriteLoading: boolean;
    editFavoriteErrors: readonly ExecutionError[] | string;
}

export const useEditFavorite = (): IUseEditFavoriteReturnType => {
    const [ errorOp, setErrorOp ] = useState('');
    const { load, loading: isLoading, errors } = useManualGql<
        AgentEditFavoriteMutation$variables,
        AgentEditFavoriteMutation$data & QueryErrors
    >(AgentEditFavoriteMutation);

    const onEditFavorite = useCallback(
        (args: AgentEditFavoriteMutation$variables) => {
            return load(args)
                .then(res => {
                    const isHasError = Boolean(res.errors) || Boolean(res.message);

                    if (isHasError) throw res;

                    return res;
                })
                .catch((errs: Error[] | Error) => {
                    const errorMesasge = errs.toString();

                    // eslint-disable-next-line no-console
                    console.error('onEditFavorite error', errorMesasge);

                    setErrorOp(errorMesasge);
                    throw errorMesasge;
                });
        },
        [ load ]
    );

    return {
        onEditFavorite,
        editFavoriteLoading: isLoading,
        editFavoriteErrors: errors ?? errorOp
    };
};
